export const isCheckboxChecked = (value) => {
    if (Array.isArray(value))
        return isCheckboxChecked(value[0]);
    if (typeof value === 'boolean')
        return value;
    const normalized = String(value ?? '').trim().toLowerCase();
    return normalized === 'true' || normalized === '1';
};
